import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Alert } from '../../../components/atoms';
import { LoadingView } from '../../../../common/components/atoms';
import { ERROR_MESSAGE } from '../../../common/constants.js';

import { validationEmail } from '../../../../common/helper/validation.js';
import logo from '../../../components/atoms/data/logo.png';

class Remind extends Component {
    constructor(props) {
        super(props);

        this.refAlert = React.createRef();
        this.state = {
            address: "",
            confirm: "",
            displayAlert: false,
            errorMessage: "",
        }
    }
    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
    }
    onSuccess = () => {
        this.props.history.push('/login');
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onClickSendMail = (e) => {
        if (this.state.address !== this.state.confirm) {
            this.refAlert.current.setAlertAnime();
            this.setState({ 
                errorMessage: ERROR_MESSAGE["discrepancy_mail"],
                displayAlert: true
            });
        } else {
            if(validationEmail(this.state.address)){
                this.props.dispatch({
                    type: "LoadStart"
                });
                this.props.dispatch({
                    type: 'PWResetRequest_Saga',
                    address: this.state.address,
                    onSuccess: this.onSuccess,
                    onFailure: this.onFailure,
                });
            } else {
                this.refAlert.current.setAlertAnime();
                this.setState({ 
                    errorMessage: ERROR_MESSAGE["invalid_mail"],
                    displayAlert: true
                });
            }
        }
    }

    onClickBack = (e) => {
        this.props.history.push('/login');
    }

    onChange = (e) => {
        const {name, value} = e.target;
        this.setState({
            [name]: value
        })
    }

    render() {
        const propAlert = {
            display: this.state.displayAlert,
            message: this.state.errorMessage,
        }
        return (
            <Body>
                <Logo src={logo}/>
                <Input>
                    <input type="text" name="address" value={this.state.address} placeholder="メールアドレス"
                        onChange={this.onChange}></input>
                </Input>
                <Input>
                    <input type="text" name="confirm" value={this.state.confirm} placeholder="確認用"
                        onChange={this.onChange}></input>
                </Input>
                <Alert ref={this.refAlert} {...propAlert} />
                <Buttons>
                    <Button Color="#0077FF" onClick={this.onClickSendMail}>
                        メール送信
                    </Button>
                    <Button Color="#707070" onClick={this.onClickBack}>
                        戻る
                    </Button>
                </Buttons>
                <LoadingView Display={this.props.loading} />
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        loading: store.loading.loading,
    }
};

const connectedRemind = connect(mapStateToProps)(Remind);
export { connectedRemind as Remind };

const Body = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 32px 0;
`;
const Logo = styled.img`
    width: 208px;
    height: 32px;
    margin-bottom: 32px;
`;
const Input = styled.div `
    width: 100%;
    max-width: 320px;
    text-align: center;
    margin: 20px 0;
    font-size: 20px;
    input {
        width: 80%;
        font-size: 20px;
        padding: 10px 20px;
    }
`;

const Buttons = styled.div`
    position: fixed;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;
const Button = styled.div`
    font-size: 20px;
    padding: 10px 20px;
    background-color: ${props => (props.Color)};
    color: #fff;
    border-radius: 50px;
    width: 80%;
    text-align: center;
    cursor: pointer;
    :nth-of-type(n+2) {
        margin-top: 10px;
    }
`;
